<template>
  <!-- 리사이즈 핸들: 좌/상/좌상단 — 우하단 고정 패널이라 바깥쪽으로 끌면 커진다.
    포인터 캡처로 move/up이 핸들에 전달되므로 리스너는 핸들에만 둔다. 더블클릭=기본 크기 복귀.
    터치 전용 기기(coarse pointer)는 6px 엣지 조작이 실질 불가 + 스크롤 제스처 간섭 → 미노출. -->
  <template v-if="resizable">
    <div
      v-for="mode in ['l', 't', 'tl']"
      :key="mode"
      class="aw-resize"
      :class="`aw-resize--${mode}`"
      aria-hidden="true"
      @pointerdown="onStart($event, mode)"
      @pointermove="onMove"
      @pointerup="onEnd"
      @pointercancel="onEnd"
      @dblclick="onReset"
    ></div>
  </template>
</template>

<script>
/**
 * @component AssistantResizeHandles
 * @description 어시스턴트 패널 리사이즈 핸들 3종(좌/상/좌상단). 드래그 로직은
 * usePanelResize composable(부모 소유)을 props 함수로 위임받아 호출만 한다.
 * 부모(.aw-panel)가 position: fixed 이므로 absolute 핸들이 패널 가장자리에 앵커된다.
 */
export default {
  name: 'AssistantResizeHandles',
  props: {
    /** usePanelResize.startResize */
    onStart: { type: Function, required: true },
    /** usePanelResize.onResizeMove */
    onMove: { type: Function, required: true },
    /** usePanelResize.endResize */
    onEnd: { type: Function, required: true },
    /** usePanelResize.resetSize */
    onReset: { type: Function, required: true }
  },
  data() {
    return {
      // 터치 전용 기기 판별 — 뷰포트 폭 분기가 아니므로 useResponsive 대상 아님(SURINP-302)
      resizable: !(typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches)
    }
  }
}
</script>

<style scoped>
/* ── 리사이즈 핸들: 커서/히트 영역 제공(가장자리 6px, 모서리 16px) + 모서리 그립 힌트.
   touch-action: none — 드래그가 스크롤로 새지 않게 함 ── */
.aw-resize {
  position: absolute;
  z-index: 1;
  touch-action: none;
}
.aw-resize--l {
  top: 0;
  left: 0;
  bottom: 0;
  width: 6px;
  cursor: ew-resize;
}
.aw-resize--t {
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  cursor: ns-resize;
}
.aw-resize--tl {
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  cursor: nwse-resize;
}
/* 모서리 그립 시각 힌트 — 헤더(primary) 배경 위 흰색 반투명 사선 2줄, 호버 시 강조 */
.aw-resize--tl::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    transparent 5px,
    currentColor 5px,
    currentColor 7px,
    transparent 7px,
    transparent 10px,
    currentColor 10px,
    currentColor 12px,
    transparent 12px
  );
  color: var(--color-white, #fff);
  opacity: 0.45;
  transition: opacity 0.15s;
}
.aw-resize--tl:hover::before { opacity: 0.9; }
</style>
